<template>
  <div>
    <el-tabs type="border-card">
      <el-tab-pane label="资讯生成列表">
        <div style="background: #ffffff; position: relative">
          <div class="search-condition-con" :class="'show'">
            <div class="search-condition">
              <span class="label">动态分类</span>
              <div class="input-condition">
                <el-select v-model="condition.type_id" placeholder="请选择" clearable>
                  <el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </div>
            </div>
            <div class="search-condition">
              <span class="label">模板名称</span>
              <div class="input-condition">
                <el-input v-model="condition.template_name" maxlength="30" placeholder="请输入模板名称"></el-input>
              </div>
            </div>
            <div class="search-condition">
              <span class="label">动态标题</span>
              <div class="input-condition">
                <el-input v-model="condition.trend_title" maxlength="30" placeholder="请输入动态标题"></el-input>
              </div>
            </div>
            <div class="search-condition">
              <span class="label">站点</span>
              <div class="input-condition">
                <site-auto-complete v-model="condition.site_id" :clueId="1" :init-choose-first="false" :owned="true"
                  ref="siteAutoComplete" @created="initData" clearable></site-auto-complete>
              </div>
            </div>
            <div class="search-condition search-condition-time" style="min-width: 400px">
              <span class="label">生成时间</span>
              <div class="input-condition">
                <el-date-picker v-model="condition.trend_time" type="datetimerange" range-separator="至"
                  start-placeholder="开始日期" end-placeholder="结束日期" align="right" value-format="yyyy-MM-dd HH:mm"
                  format="yyyy-MM-dd HH:mm" @change="condition.timestamp = ''">
                </el-date-picker>
              </div>
            </div>
            <div class="search-condition search-condition-time" style="min-width: 400px">
              <span class="label">执行时间</span>
              <div class="input-condition">
                <el-date-picker v-model="condition.time" type="datetimerange" range-separator="至"
                  start-placeholder="开始日期" end-placeholder="结束日期" align="right" value-format="yyyy-MM-dd HH:mm"
                  format="yyyy-MM-dd HH:mm" @change="condition.timestamp = ''">
                </el-date-picker>
              </div>
            </div>
          </div>
          <div class="btn-condition">
            <el-button type="primary" @click="handleSearch()">查 询</el-button>
            <el-button @click="resetSearch()">清空条件</el-button>
            <el-button-group class="floatR" style="margin-left: 20px">
              <el-tooltip class="item" effect="dark" content="导出" placement="top"
                v-permission="'operating.house-trend-model-manage.trend-create-list.export'">
                <el-button icon="el-icon-download" @click="exportList"></el-button>
              </el-tooltip>
            </el-button-group>
          </div>
        </div>
        <el-table :data="list" style="width: 100%" :highlight-current-row="true" stripe tooltip-effect="dark"
          ref="multipleTable" v-loading="isLoading" header-cell-class-name="table-back" class="list-table">
          <el-table-column label="动态ID" prop="trend_id" align="center"></el-table-column>
          <el-table-column label="动态标题" prop="trend_title" align="center">
            <template slot-scope="scope">
              <a :href="scope.row.trend_url" target="_blank" style="color:#0099FF;">{{ scope.row.trend_title }}</a>
            </template>
          </el-table-column>
          <el-table-column label="楼盘名称" prop="house_name" align="center">
            <template slot-scope="scope">
              <a :href="scope.row.house_url" target="_blank" style="color:#0099FF;">{{ scope.row.house_name }}</a>
            </template>
          </el-table-column>
          <el-table-column label="站点" prop="site_name" align="center">
            <template slot-scope="scope">
              <a :href="scope.row.site_url" target="_blank" style="color:#0099FF;">{{ scope.row.site_name }}</a>
            </template>
          </el-table-column>
          <el-table-column label="动态分类" prop="type_name" align="center"></el-table-column>
          <el-table-column label="模板名称" prop="template_name" align="center"></el-table-column>
          <el-table-column label="添加人" prop="operator" align="center"></el-table-column>
          <el-table-column label="生成时间" prop="trend_created_at" align="center"></el-table-column>
          <el-table-column label="执行时间" prop="created_at" align="center"></el-table-column>

        </el-table>
        <template v-if="list.length > 0">
          <el-pagination background layout="total,prev, pager, next" :current-page="condition.page"
            :total="condition.total" :page-size="condition.per_page" @current-change="currentChange"></el-pagination>
        </template>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import { tplRecordstrends } from '@/service/dynamicModel'
import { NEWS_MODEL } from "@/config/index";
import SiteAutoComplete from "@/components/auto-complete/site-auto-complete";
export default {
  components: {
    SiteAutoComplete
  },
  data() {
    return {
      typeList: [{
        id: 1,
        name: "楼盘动态"
      }, {
        id: 2,
        name: "开盘信息"
      }, {
        id: 3,
        name: "交房信息"
      }, {
        id: 4,
        name: "证件信息"
      }],
      list: [],
      condition: {
        type_id: "",
        template_name: "",
        trend_title: "",
        site_id: "",
        time: "",
        trend_time: "",
        per_page: 10,
        total: 0,
        page: 1,
      },
      isLoading: false,
      exportCondition: null
    };
  },
  mounted() {
    // this.typeList = NEWS_MODEL.news_types;
  },
  methods: {
    handleSearch() {
      this.condition.page = 1;
      this.initData();
    },
    resetSearch() {
      this.condition = {
        type_id: "",
        template_name: "",
        trend_title: "",
        site_id: "",
        time: "",
        trend_time: "",
        per_page: 10,
        total: 0,
        page: 1,
      };
      this.initData();
    },
    async initData() {
      this.list = [];
      let query = {
        type_id: this.condition.type_id,
        template_name: this.condition.template_name,
        trend_title: this.condition.trend_title,
        site_id: this.condition.site_id,
        per_page: this.condition.per_page,
        total: this.condition.total,
        page: this.condition.page,
      }
      if (this.condition.trend_time && this.condition.trend_time.length > 1) {
        query.trend_created_at_start = this.condition.trend_time[0];
        query.trend_created_at_end = this.condition.trend_time[1];
      } else {
        delete query.trend_created_at_start;
        delete query.trend_created_at_end;
      }
      if (this.condition.time && this.condition.time.length > 1) {
        query.created_at_start = this.condition.time[0];
        query.created_at_end = this.condition.time[1];
      } else {
        delete query.created_at_start;
        delete query.created_at_end;
      }
      this.isLoading = true
      await tplRecordstrends(query).then((data) => {
        let siteurl = window.serverConfig[window.siteMap[domain]].VUE_APP_HOST.substring(14);
        let url = "https://cs." + siteurl + '/loupan/dongtai/preview/';
        data.data.forEach((item, index) => {
          data.data[index].url = url + item.id + '.html';
        })

        this.condition.total = data.total;
        this.list = data.data;
      });
      this.exportCondition = { ... this.condition }
      //数据请求完毕取消当前页面的loading
      this.isLoading = false;
    },
    currentChange(index) {
      this.condition.page = index;
      this.initData();
    },
    async exportList() {
      if (!this.list.length) {
        this.$message({
          message: "请先查询需要导出的数据",
          type: 'error',
          duration: 3 * 1000
        })
        return
      }
      let query = {
        type_id: this.exportCondition.type_id,
        template_name: this.exportCondition.template_name,
        trend_title: this.exportCondition.trend_title,
        site_id: this.exportCondition.site_id,
        per_page: this.exportCondition.total,
        total: this.exportCondition.total,
        page: this.exportCondition.page,
      }
      if (this.condition.trend_time && this.condition.trend_time.length > 1) {
        query.trend_created_at_start = this.condition.trend_time[0];
        query.trend_created_at_end = this.condition.trend_time[1];
      } else {
        delete query.trend_created_at_start;
        delete query.trend_created_at_end;
      }
      if (this.exportCondition.trend_time && this.exportCondition.trend_time.length > 0) {
        } else {
          this.$message({
            message: "请选择生成时间段",
            type: "error",
            duration: 3 * 1000,
          });
          return;
        }
      let list = null
      await tplRecordstrends(query).then((data) => {
        let siteurl = window.serverConfig[window.siteMap[domain]].VUE_APP_HOST.substring(14);
        let url = "https://cs." + siteurl + '/loupan/dongtai/preview/';
        data.data.forEach((item, index) => {
          data.data[index].url = url + item.id + '.html';
        })
        list = data.data
      });
      import("@/vendor/Export2Excel").then(async (excel) => {
        const tHeader = [
          "动态ID",
          "动态标题",
          "楼盘名称",
          "站点",
          "动态分类",
          "模板名称",
          "添加人",
          "生成时间",
          "执行时间",
          "前台链接"
        ];
        const filterVal = [
          "trend_id",
          "trend_title",
          "house_name",
          "site_name",
          "type_name",
          "template_name",
          "operator",
          "trend_created_at",
          "created_at",
          "trend_url",
        ];
        const formatJson = (filterVal) => {
          return list.map((v) =>
            filterVal.map((j) => {
              return v[j];
            })
          );
        };
        const data = formatJson(filterVal);
        const filename = "动态建模生成列表[" + this.exportCondition.trend_time[0].slice(0, 10) + "至" + this.exportCondition.trend_time[1].slice(0, 10)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: filename,
        });
        this.isLoading = false;
      });
    },
  },
};
</script>
<style lang="less" scoped>

</style>